import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  WORK_ORDER,
  AP_INVOICE,
  BUDGET,
  CONTRACT,
  PM_YEARLY_LIMIT,
  BLANKET_LIMIT,
  BOARD_LEVEL_APPROVAL,
  PM_APPROVAL_LIMIT,
  SINGLE_APPROVAL,
} from "./consts";
import { useGetCommunityApprovalInfo } from "@/services";
import { useEffect } from "react";
import { getRequiredFields } from "@/lib/utils";
import { schema } from "./validations";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

const useStep4 = () => {
  const form = useForm<any>({
    defaultValues: {
      [AP_INVOICE]: "1",
      [BUDGET]: "1",
      [CONTRACT]: "1",
      [WORK_ORDER]: "1",
      [PM_YEARLY_LIMIT]: "1",
      [BLANKET_LIMIT]: "1",
      [BOARD_LEVEL_APPROVAL]: "1",
      [PM_APPROVAL_LIMIT]: "1",
      [SINGLE_APPROVAL]: "1",
    },
    resolver: zodResolver(schema),
  });

  // Dynamically determine required fields
  const requiredFields = getRequiredFields(schema);

  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );

  const {
    data: communityApprovalInfo,
    isLoading: isApprovalInfoLoading,
    isRefetching: isApprovalInfoRefetching,
  } = useGetCommunityApprovalInfo({
    community_id: communityData?.communityId || "",
    queryParams: {
      enabled: !!communityData?.communityId,
    },
  });

  useEffect(() => {
    if (communityApprovalInfo) {
      form.reset({
        [AP_INVOICE]:
          communityApprovalInfo?.data?.[AP_INVOICE]?.toString() || "1",
        [BUDGET]: communityApprovalInfo?.data?.[BUDGET]?.toString() || "1",
        [CONTRACT]: communityApprovalInfo?.data?.[CONTRACT]?.toString() || "1",
        [WORK_ORDER]:
          communityApprovalInfo?.data?.[WORK_ORDER]?.toString() || "1",
        [PM_YEARLY_LIMIT]:
          communityApprovalInfo?.data?.[PM_YEARLY_LIMIT]?.toString() || "1",
        [BLANKET_LIMIT]:
          communityApprovalInfo?.data?.[BLANKET_LIMIT]?.toString() || "1",
        [BOARD_LEVEL_APPROVAL]:
          communityApprovalInfo?.data?.[BOARD_LEVEL_APPROVAL]?.toString() ||
          "1",
        [PM_APPROVAL_LIMIT]:
          communityApprovalInfo?.data?.[PM_APPROVAL_LIMIT]?.toString() || "1",
        [SINGLE_APPROVAL]:
          communityApprovalInfo?.data?.[SINGLE_APPROVAL]?.toString() || "1",
      });
    }
  }, [communityApprovalInfo]);

  return {
    form,
    requiredFields,
    isApprovalInfoLoading,
    isApprovalInfoRefetching,
  };
};

export default useStep4;
